var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineLeftToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 105,
    viewBox: "0 0 664 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0V28.5C1.25 41.7548 11.9952 52.5 25.25 52.5H638.75C652.005 52.5 662.75 63.2452 662.75 76.5V105",
    stroke: "url(#paint0_linear_9684_42952)",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9684_42952",
    x1: 0.999997,
    y1: 59,
    x2: 663,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0FCBA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5346,
    stopColor: "#98FEB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFFFC5",
    stopOpacity: 0.2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLeftToRight);
export default __webpack_public_path__ + "static/media/line-left-to-right.a5c9ddfbeddb68197302c1b6bef90118.svg";
export { ForwardRef as ReactComponent };